// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Pf0sd","type":"styles_type__2oo3m","choices":"styles_choices__4Huik"};